import { render, staticRenderFns } from "./HowBuySlide.vue?vue&type=template&id=5bb7de15&scoped=true&"
import script from "./HowBuySlide.vue?vue&type=script&lang=js&"
export * from "./HowBuySlide.vue?vue&type=script&lang=js&"
import style0 from "./HowBuySlide.vue?vue&type=style&index=0&id=5bb7de15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7de15",
  null
  
)

export default component.exports